import { useEffect } from 'react';

import { LOCAL_STORAGE_KEYS } from '../../../constants/system/LOCAL_STORAGE_KEYS';
import { reloadPage } from '../../../utils/windowUtils';

export const useTabSynchronization = () => {
  const onStorageChange = (event: StorageEvent) => {
    const isValueChanged = event.newValue !== event.oldValue;
    const isReloadOtherTabs = event.key === LOCAL_STORAGE_KEYS.RELOAD_OTHER_TABS;
    if (isReloadOtherTabs && isValueChanged) {
      reloadPage();
    }
  };

  useEffect(() => {
    window.addEventListener('storage', onStorageChange);
    return () => {
      window.removeEventListener('storage', onStorageChange);
    };
  });
};
